import * as React from 'react';
import Select from 'antd/lib/select';
import { CommonProps } from './common.intefaces';
import { ModesOfService } from 'src/Library/Constants';

interface IProps extends CommonProps {
  allowedMode: Record<ModesOfService, string>;
  showRoadinsteadOfDomestic?: boolean;
}

const ModeSelect = (props: IProps) => {

  const {
    mode,
    style,
    value,
    onChange,
    disabled,
    className,
    placeholder,
    allowedMode,
    showRoadinsteadOfDomestic
  } = props;

  const renderModeOptions = () => {
    return Object.keys(allowedMode)?.map((mode) => {
      // Get the label from allowedMode
      let label = allowedMode[mode];
      
      // If showRoadinsteadOfDomestic is true and mode is DOMESTIC, change label to "Road"
      if (showRoadinsteadOfDomestic && mode === ModesOfService.DOMESTIC) {
        label = "Road";
      }
      
      return (
        <Select.Option key={mode} value={mode}>
          {label}
        </Select.Option>
      );
    }) || [];
  };

  return <Select
    style={{
      ...(style || {}),
    }}
    allowClear
    showSearch
    value={value}
    disabled={disabled}
    onChange={onChange}
    className={className}
    mode={mode || 'default'}
    placeholder={placeholder || 'Select Mode'}
    getPopupContainer={(trigger: any) => trigger.parentNode}
  >
    {renderModeOptions()}
  </Select>;
};

export default React.memo(ModeSelect);